// reducers/UserSlice.ts
import { createSlice } from "@reduxjs/toolkit";
import { LoadState, User } from "../types/commonTypes";
import userApi from "../api/userApi";

interface UserState {
  users: User[];
  loadState: LoadState;
  error: string | null;
}

const initialState: UserState = {
  users: [],
  loadState: LoadState.INIT,
  error: null,
};

const userSlice = createSlice({
  name: "user",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addMatcher(
      userApi.endpoints.fetchAllUsers.matchFulfilled,
      (state, { payload }) => {
        state.users = payload;
        state.loadState = LoadState.LOADED;
        state.error = null;
      }
    );
    builder.addMatcher(
      userApi.endpoints.fetchAllUsers.matchPending,
      (state) => {
        state.loadState = LoadState.LOADING;
        state.error = null;
      }
    );
    builder.addMatcher(
      userApi.endpoints.fetchAllUsers.matchRejected,
      (state, { error }) => {
        state.loadState = LoadState.ERROR;
        state.error = error.message || "Failed to fetch users";
      }
    );
  },
});

export default userSlice.reducer;
